module.exports = __webpack_public_path__ + "static/media/lone_druid.10fb5692.png";